import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";
import Interview from "@/pages/Interview";
import LabGate from "@/pages/LabGate";
import { ContentProvider } from "@/data/ContentContext";

function App() {
  return (
    <div className="App">
      <ContentProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/interview/:slug" element={<Interview />} />
            {/* Legacy shortcuts for the original TÜV SÜD interview */}
            <Route path="/TUVSUD" element={<Interview slug="tuvsud" />} />
            <Route path="/tuvsud" element={<Interview slug="tuvsud" />} />
            {/* Private AI Transformation Hub */}
            <Route path="/lab" element={<LabGate />} />
            <Route path="/Lab" element={<LabGate />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </BrowserRouter>
      </ContentProvider>
    </div>
  );
}

export default App;
